/**
 * Shared constants — imported by backend, web, and mobile.
 * Single source of truth for enumerated values used across apps.
 */

export const ROLES = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  OWNER: 'owner',
  BRANCH_MANAGER: 'branch_manager',
  ACCOUNTANT: 'accountant',
  INVENTORY_MANAGER: 'inventory_manager',
  PURCHASE_MANAGER: 'purchase_manager',
  DISPATCHER: 'dispatcher',
  CASHIER: 'cashier',
  KITCHEN_STAFF: 'kitchen_staff',
  RIDER: 'rider',
});

/** Roles that bypass individual permission checks. */
export const PRIVILEGED_ROLES = Object.freeze([ROLES.SUPER_ADMIN, ROLES.OWNER]);

export const ORDER_TYPES = Object.freeze([
  'dine_in',
  'takeaway',
  'delivery',
  'foodpanda',
  'phone_order',
  'online',
  'complimentary',
  'staff_meal',
]);

export const ORDER_STATUSES = Object.freeze([
  'new',
  'confirmed',
  'preparing',
  'ready',
  'packed',
  'dispatched',
  'delivered',
  'completed',
  'cancelled',
  'refunded',
]);

export const PAYMENT_METHODS = Object.freeze([
  'cash',
  'card',
  'online',
  'wallet',
  'foodpanda',
  'split',
  'complimentary',
]);

export const KITCHEN_TICKET_STATUSES = Object.freeze([
  'new',
  'accepted',
  'preparing',
  'ready',
  'packed',
  'completed',
  'cancelled',
]);

export const INVENTORY_TRANSACTION_TYPES = Object.freeze([
  'PURCHASE_RECEIPT',
  'SALE_CONSUMPTION',
  'WASTAGE',
  'TRANSFER_OUT',
  'TRANSFER_IN',
  'STOCK_ADJUSTMENT',
  'STAFF_MEAL',
  'COMPLIMENTARY',
  'SUPPLIER_RETURN',
  'PRODUCTION',
  'OPENING_BALANCE',
  'PHYSICAL_COUNT_ADJUSTMENT',
]);

/** Chart-of-accounts codes referenced by the accounting engine. */
export const ACCOUNTS = Object.freeze({
  CASH_ON_HAND: '1101',
  POS_CASH: '1102',
  BANK: '1103',
  FOODPANDA_RECEIVABLE: '1201',
  INVENTORY: '1301',
  SUPPLIER_PAYABLE: '2101',
  SALES_TAX_PAYABLE: '2201',
  REVENUE_DEFAULT: '4100',
  COGS: '5101',
  WASTAGE: '5200',
});

export const REVENUE_ACCOUNT_BY_ORDER_TYPE = Object.freeze({
  dine_in: '4101',
  takeaway: '4102',
  delivery: '4103',
  foodpanda: '4104',
  online: '4105',
});
